/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import { Bundle } from '_core/util';
import Definitions from '../Definitions';
import { DocumentValueType } from '../Types/CommonTypes';

export type ValidateEmailRequestType = {
  email: string;
  document?: DocumentValueType;
};

const definitions = Definitions.ValidateEmail;

const callPost = async (
  params: ValidateEmailRequestType,
): Promise<IFinalResponse> => {
  const smilesToken = Bundle.getValue('smilesToken');

  const init: InitApiType = {
    body: {
      ...params,
      smilesToken,
    },
  };

  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };
export default { call, definitions };
